/* Choose your size: on product pages, the Size buttons start unselected and Add to cart (main button
   and the sticky phone bar) asks the shopper to pick a size first. Dawn still keeps a variant selected
   behind the scenes (it needs one for price and stock); this only changes what the shopper sees and
   stops the add until they have tapped a size themselves.
   Size fieldsets are marked in snippets/product-variant-picker.liquid with data-size-option and,
   until a size is tapped, data-size-unchosen. Opening a link with ?variant= counts as chosen. */
(function () {
  if (window.sizeRequiredReady) return;
  window.sizeRequiredReady = true;

  var chosen = new Set();

  function keyOf(el) {
    var vs = el && el.closest ? el.closest('variant-selects') : null;
    return vs ? vs.dataset.section : '';
  }

  function mainProductInfo() {
    return Array.prototype.find.call(document.querySelectorAll('product-info'), function (el) {
      return !el.closest('quick-add-modal');
    });
  }

  function unchosenIn(root) {
    return root ? root.querySelector('fieldset[data-size-unchosen]') : null;
  }

  function stickyText() {
    var el = document.querySelector('sticky-buy-bar [data-sticky-variant-text]');
    var info = mainProductInfo();
    if (!el || !info) return;
    if (!unchosenIn(info)) return;
    var parts = [];
    info.querySelectorAll('variant-selects fieldset:not([data-size-option])').forEach(function (fs) {
      var checked = fs.querySelector('input[type=radio]:checked');
      if (checked) parts.push(checked.value);
    });
    parts.push('Choose a size');
    var text = parts.join(' / ');
    if (el.textContent !== text) el.textContent = text;
  }

  function apply() {
    document.querySelectorAll('fieldset[data-size-unchosen]').forEach(function (fs) {
      if (chosen.has(keyOf(fs))) {
        fs.removeAttribute('data-size-unchosen');
        var msg = fs.parentNode.querySelector('[data-size-msg]');
        if (msg) msg.hidden = true;
      }
    });
    stickyText();
  }

  function scrollToSizes(fs) {
    var target = Math.max(0, fs.getBoundingClientRect().top + window.scrollY - window.innerHeight / 3);
    try {
      window.scrollTo({ top: target, behavior: 'smooth' });
    } catch (err) {
      window.scrollTo(0, target);
    }
    /* Some browsers drop a smooth scroll that starts while another is running: make sure we got there */
    setTimeout(function () {
      var r = fs.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) window.scrollTo(0, target);
    }, 700);
  }

  function block(e, fs) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var msg = fs.parentNode.querySelector('[data-size-msg]');
    if (msg) msg.hidden = false;
    fs.classList.add('size-required--alert');
    setTimeout(function () { fs.classList.remove('size-required--alert'); }, 1200);
    scrollToSizes(fs);
    var first = fs.querySelector('input[type=radio]:not(.disabled)') || fs.querySelector('input[type=radio]');
    if (first) first.focus({ preventScroll: true });
  }

  /* Opened from a link that already names a variant (e.g. a lookbook link or a swatch): treat as chosen */
  if (/[?&]variant=/.test(location.search)) {
    document.querySelectorAll('variant-selects').forEach(function (vs) { chosen.add(vs.dataset.section); });
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var radio = t.closest('fieldset[data-size-option] input[type=radio]');
      if (radio) {
        chosen.add(keyOf(radio));
        apply();
        return;
      }

      var submit = t.closest('.product-form__submit');
      if (submit) {
        var fs = unchosenIn(submit.closest('product-info'));
        if (fs) block(e, fs);
        return;
      }

      var sticky = t.closest('[data-sticky-action="add-to-cart"]');
      if (sticky) {
        var fs2 = unchosenIn(mainProductInfo());
        if (fs2) block(e, fs2);
      }
    },
    true
  );

  /* Keyboard: Enter or Space on a size label/input also counts as choosing */
  document.addEventListener(
    'change',
    function (e) {
      var radio = e.target && e.target.closest && e.target.closest('fieldset[data-size-option] input[type=radio]');
      if (radio) {
        chosen.add(keyOf(radio));
        apply();
      }
    },
    true
  );

  /* Backstop: any submit of a product form without a chosen size */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.id || form.id.indexOf('product-form-') !== 0) return;
      var section = form.id.replace('product-form-', '');
      var vs = document.querySelector('variant-selects[data-section="' + section + '"]');
      var fs = vs ? vs.querySelector('fieldset[data-size-unchosen]') : null;
      if (fs) block(e, fs);
    },
    true
  );

  /* Dawn re-renders the option buttons after each choice; keep the state */
  if ('MutationObserver' in window) {
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(apply, 0);
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
